"use client";

import React, { useState, type ReactElement } from "react";
import { twMerge } from "tailwind-merge";

import type { ButtonSkin } from "@rootreeweb/ui";
import { Button } from "@rootreeweb/ui";

type Props = {
	buttonTheme: ButtonSkin;
	content: string[] | string[][];
	title: string;
};

/**
 * A button that displays a random output from a list of options.
 *
 * @param props The props for the component.
 * @returns The component.
 */
export default function RandomButton(props: Props): ReactElement {
	const { buttonTheme, content, title } = props;
	const [randomOutput, setRandomOutput] = React.useState<string | string[]>("");
	const [revealed, setRevealed] = useState(false);

	return (
		<div className="hl:my-4 hl:rounded hl:bg-[rgb(0_0_0/25%)] hl:p-4">
			<div>
				<div className="hl:my-4 hl:flex hl:items-center hl:justify-center">
					<Button
						colour={buttonTheme}
						onClick={() => {
							setRandomOutput(
								content[Math.floor(Math.random() * content.length)],
							);
							setRevealed(false);
						}}
					>
						{title}
					</Button>
				</div>
				<div className="hl:text-center">
					{Array.isArray(randomOutput) ? randomOutput[0] : randomOutput}
				</div>
				<div
					className={twMerge(
						"hl:p-2",
						Array.isArray(randomOutput) ? "hl:block" : "hl:hidden",
					)}
				>
					{revealed ? (
						randomOutput[1]
					) : (
						<Button
							className={"hl:mx-auto"}
							onClick={() => {
								setRevealed(true);
							}}
						>
							Reveal
						</Button>
					)}
				</div>
			</div>
		</div>
	);
}
